import React, {useEffect, useState} from "react";
import {ReactComponent as LogoIcon} from "../../icons/logo.svg";
import {ReactComponent as BurgerIcon} from "../../icons/burger.svg";
import {ReactComponent as CloseIcon} from "../../icons/close.svg";
import {ReactComponent as MobileProfileIcon} from "../../icons/mobile-profile.svg";
import {NavButton} from "../ui/buttons/NavButton";
import {Link, useLocation, useNavigate} from "react-router-dom";

const HeaderContent = () => {
  // DEV
  const dev = true;
  const navigate = useNavigate();
  const location = useLocation();

  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);
  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const handleProfileClick = () => {
    closeMenu();
    navigate("/profile");
  };

  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  return (
    <header className="header-content">
      <div className="header-content-inside w-[100%]">
        <div className="flex flex-row items-center gap-20">
          <div className="header-logo">
            <LogoIcon className="header-logo-icon cursor-pointer" onClick={() => navigate("/")}/>
          </div>

          <nav className="desktop-menu menu-text">
            <Link to="/all-curses">Курсы валют</Link>
            <Link to="/exchange/create">Обмен валют</Link>
            <Link to="/exchange/my">Мои обмены</Link>
            <Link to="/usd-amount">Счет в США</Link>
          </nav>
        </div>

        <NavButton className="desktop-button profile-trigger" onClick={() => navigate("/profile")}>
          <MobileProfileIcon className="desktop-profile-icon"/>
          Личный кабинет
        </NavButton>

        <div className="menu-toggle" onClick={toggleMenu}>
          {menuOpen ? <CloseIcon className="menu-icon"/> : <BurgerIcon className="menu-icon"/>}
        </div>
      </div>

      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <nav className="menu-links">
          <Link to="/all-curses">Курсы валют</Link>
          <Link to="/exchange/create" onClick={closeMenu}>Обмен валют</Link>
          <Link to="/exchange/my" onClick={closeMenu}>Мои обмены</Link>
          <Link to="/usd-amount" onClick={closeMenu}>Счет в США</Link>
        </nav>

        <button className="menu-button mobile-menu-button" onClick={handleProfileClick}>
          <MobileProfileIcon className="mobile-profile-icon"/>
          Личный кабинет
        </button>
      </div>
    </header>
  );
};

export default HeaderContent;